import StatCard from "pages/dashboard-overview/components/StatCard";
import StatCardSkeleton from "./StatCardSkeleton";

export default function KpiCard({
  title,
  value,
  suffix = "",
  icon,
  subtitle,
  isLoading = false,
}) {
  if (isLoading) return <StatCardSkeleton />;

  return (
    <StatCard
      title={title}
      value={value}
      suffix={suffix}
      icon={icon}
      subtitle={subtitle}
    />
  );
}
